import React, { Component } from 'react'
import { connect } from 'react-redux'
import SearchBar from '../../v2/SearchBar'
import FeedbackDetailBar from '../../v2/FeedbackDetailBar'
import FilterBar from '../../v2/FilterBar'
import FeedbackDetail from '../../v2/FeedbackDetail'
import FeedbackInbox from '../../v2/FeedbackInbox'
import Modal from '../../Modal'

class Archive extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        {
          !this.props.state.feedback_detail ?
            <SearchBar />
            :
            null
        }
        {this.props.state.feedback_detail ?
          <FeedbackDetailBar />
          :
          <FilterBar />
        }
        {this.props.state.feedback_detail ?
          <FeedbackDetail />
          :
          <FeedbackInbox />
        }

        <Modal modal={this.props.state.modal} />
      </>
    )
  }
}

function mapStateToProps(state) {
  return { state: state }
}

export default connect(mapStateToProps)(Archive)
